import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Order } from '../customize-picking-list/picking-list-storage.service';

@Injectable({
    providedIn: 'root'
})
export class CustomizePickingListService {
    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) {}

    /** Create a new driver */
    createDriver(driverName: string, companyId: string, divisionId: string): Observable<any> {
        const body = {
            driverName,
            company: companyId,
            division: divisionId,
            status: '20'
        };
        const url = `${this.baseUrl}Driver/CreateDriver`;
        return this.http.post(url, body);
    }

    /** Create a new vehicle */
    createVehicle(vehicleNumber: string, companyId: string, divisionId: string): Observable<any> {
        const body = {
            vehicleNumber,
            company: companyId,
            division: divisionId,
            status: '20'
        };
        const url = `${this.baseUrl}Vehicle/CreateVehicle`;
        return this.http.post(url, body, { responseType: 'text' });
    }
    /** Fetch all active drivers */
    getDrivers(companyId: string, divisionId: string, status: string = '20'): Observable<any[]> {
        const url = `${this.baseUrl}Driver/LstDrivers?company=${companyId}&division=${divisionId}&status=${status}`;
        return this.http.get<any[]>(url);
    }

    /** Fetch all active vehicles */
    getVehicles(companyId: string, divisionId: string, status: string = '20'): Observable<any[]> {
        const url = `${this.baseUrl}Vehicle/LstVehicles?company=${companyId}&division=${divisionId}&status=${status}`;
        return this.http.get<any[]>(url);
    }
    getOrders(companyId: string, divisionId: string, fromDate: string, toDate: string, movingStatus: string = 'CRT', orderType: string = 'CustomerOrder'): Observable<Order[]> {
        const url = `${this.baseUrl}Order/GetOrderHeaders/All?orderType=${orderType}&company=${companyId}&division=${divisionId}&fromDate=${fromDate}&toDate=${toDate}&movingStatus=${movingStatus}`;
        return this.http.get<Order[]>(url);
    }
    getPickingListDetails(pklId: string): Observable<any> {
        const url = `${environment.apiUrl}InvoiceAndPicklist/OrderWise/GetPickingList?pklId=${pklId}`;
        return this.http.get<any>(url);
    }
    createPickingList(companyId: string, divisionId: string, fromDate: string, toDate: string, driverId: string, vehicleId: string, orderNumbers: number[], routeId: number = 302): Observable<any> {
        const url = `${environment.apiUrl}InvoiceAndPicklist/CreatePickingList?fromDate=${fromDate}&toDate=${toDate}&company=${companyId}&division=${divisionId}`;

        const body = {
            fromDate,
            toDate,
            status: '',
            driverId,
            vehicleId,
            orderNumbers,
            routeId
        };

        return this.http.post<any>(url, body);
    }
    getRecentPickingLists(companyId: string, divisionId: string, fromDate: string, toDate: string): Observable<any[]> {
        const url = `${environment.apiUrl}InvoiceAndPicklist/LstPickingList?company=${companyId}&division=${divisionId}&fromDate=${fromDate}&toDate=${toDate}`;
        return this.http.get<any[]>(url);
    }
    updatePickingList(
        companyId: string,
        divisionId: string,
        body: {
            pklId: number;
            fromDate: string;
            toDate: string;
            status: string;
            driverId: number | string;
            vehicleId: number | string;
            orderNumbers: number[];
            routeId: number;
        }
    ): Observable<any> {
        const url = `${environment.apiUrl}InvoiceAndPicklist/UpdatePickingList?company=${companyId}&division=${divisionId}`;
        return this.http.put<any>(url, body);
    }
    deletePickingListLine(pkllId: number, companyId: string, divisionId: string) {
        const url = `${environment.apiUrl}InvoiceAndPicklist/Delete/PickingLine?pkllId=${pkllId}&company=${companyId}&division=${divisionId}`;
        return this.http.delete<void>(url);
    }
    fetchPickingListsByDate(companyId: string, divisionId: string, fromDate: string, toDate: string) {
        const url = `${environment.apiUrl}InvoiceAndPicklist/LstPickingList?company=${companyId}&division=${divisionId}&fromDate=${fromDate}&toDate=${toDate}`;
        return this.http.get<any[]>(url);
    }
    deletePickingList(companyId: string, divisionId: string, pklId: number) {
        const url = `${environment.apiUrl}InvoiceAndPicklist/Delete?company=${companyId}&division=${divisionId}&pklId=${pklId}`;
        return this.http.put(url, {}); // using PUT as in your original code
    }
}
